module.exports = __webpack_public_path__ + "media/flags/kr-c652c7b6.svg";